import { render, staticRenderFns } from "./wig-page-tab-container.vue?vue&type=template&id=5104e039&scoped=true"
import script from "./wig-page-tab-container.vue?vue&type=script&lang=js"
export * from "./wig-page-tab-container.vue?vue&type=script&lang=js"
import style0 from "./wig-page-tab-container.vue?vue&type=style&index=0&id=5104e039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5104e039",
  null
  
)

export default component.exports